module.exports = __webpack_public_path__ + "img/Online Pharmacy.af6a4db.png";